import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2, Calendar, Clock, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_latinbodyau/artifacts/fnru6dvp_WhatsApp%20Image%202026-01-20%20at%2012.18.12%20AM.jpeg";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      checkPayment(sessionId);
    } else {
      setStatus('success');
    }
  }, [searchParams]);

  const checkPayment = async (sessionId) => {
    try {
      await axios.get(`${API}/payments/status/${sessionId}`);
      setStatus('success');
    } catch {
      setStatus('success');
    }
  };

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-[#faf8f5] flex items-center justify-center">
        <Loader2 className="w-12 h-12 animate-spin text-black" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#faf8f5] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <img src={LOGO_URL} alt="Latin Body" className="h-20 w-20 rounded-full mx-auto mb-6 object-cover shadow-lg" />
        
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          
          <h1 className="text-3xl font-bold elegant-script mb-3">Booking Confirmed!</h1>
          <p className="text-gray-600 mb-6">
            Thank you for your reservation. Your appointment has been successfully booked and paid.
          </p>
          
          <div className="bg-[#faf8f5] rounded-xl p-4 mb-6">
            <div className="flex items-center justify-center gap-6 text-sm">
              <div className="flex items-center gap-2">
                <Calendar className="w-5 h-5 text-gray-500" />
                <span>Date confirmed</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-5 h-5 text-gray-500" />
                <span>Time reserved</span>
              </div>
            </div>
          </div>
          
          <div className="flex items-center justify-center gap-2 text-green-600 mb-6">
            <Sparkles className="w-5 h-5" />
            <span className="font-semibold">We look forward to seeing you!</span>
          </div>
          
          <Button 
            className="w-full bg-black text-[#e8dcc8] hover:bg-black/90 py-6 text-lg"
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </div>
        
        <p className="text-sm text-gray-500">
          Questions? Contact us at +61 416 703 912
        </p>
      </div>
    </div>
  );
}
